var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "crown",
    clipPath: "url(#clip0_797_2640)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.6663 29.3335H9.33301C8.78634 29.3335 8.33301 28.8802 8.33301 28.3335C8.33301 27.7868 8.78634 27.3335 9.33301 27.3335H22.6663C23.213 27.3335 23.6663 27.7868 23.6663 28.3335C23.6663 28.8802 23.213 29.3335 22.6663 29.3335Z",
    fill: "url(#paint0_linear_797_2640)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M27.1336 7.36021L21.8003 11.1735C21.0936 11.6802 20.0803 11.3735 19.7736 10.5602L17.2536 3.84021C16.827 2.68021 15.187 2.68021 14.7603 3.84021L12.227 10.5469C11.9203 11.3735 10.9203 11.6802 10.2136 11.1602L4.88029 7.34688C3.81363 6.60021 2.40029 7.65355 2.84029 8.89355L8.38696 24.4269C8.57363 24.9602 9.08029 25.3069 9.64029 25.3069H22.347C22.907 25.3069 23.4136 24.9469 23.6003 24.4269L29.147 8.89355C29.6003 7.65355 28.187 6.60021 27.1336 7.36021ZM19.3336 19.6669H12.667C12.1203 19.6669 11.667 19.2135 11.667 18.6669C11.667 18.1202 12.1203 17.6669 12.667 17.6669H19.3336C19.8803 17.6669 20.3336 18.1202 20.3336 18.6669C20.3336 19.2135 19.8803 19.6669 19.3336 19.6669Z",
    fill: "url(#paint1_linear_797_2640)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_797_2640",
    x1: 15.9997,
    y1: 27.3335,
    x2: 15.9997,
    y2: 29.3335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBE627"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAE10"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_797_2640",
    x1: 15.9959,
    y1: 2.97021,
    x2: 15.9959,
    y2: 25.3069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBE627"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAE10"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_797_2640"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.cc5a645d9c7a232117bfd90fc3bbdc12.svg";
export { ForwardRef as ReactComponent };